// extracted by mini-css-extract-plugin
export default {"pageContainer":"styles_pageContainer__SJ9uG","pageGrid":"styles_pageGrid__YMmIA"};